import React from 'react';
import { useSelector } from 'react-redux';
import { animated, useSpring } from 'react-spring';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Checkmark from '../../../../shared/_TBComponents/Checkmark';
import Spinner from '../../../../shared/_TBComponents/Spinner';

const RegistrationContainer = styled('div')`
  align-items: flex-start;
  background-color: white;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  max-width: 600px;
  min-height: ${({ isIdnty }) => (isIdnty ? 'auto' : '700px')};
  padding: 40px;
  position: relative;
  width: 100%;

  @media screen and (max-width: 768px) {
    align-items: flex-start;
    min-height: auto;
    padding: 24px 20px;
  }

  @media screen and (max-width: 425px) {
    align-items: flex-start;
    border-radius: 0;
    min-height: auto;
    padding: 0 16px;
  }
`;

const TitleBox = styled('div')`
  display: flex;
  flex-direction: column;
  height: ${({ isIdnty }) => (isIdnty ? 'auto' : '70px')};
  margin-bottom: ${({ isIdnty }) => (isIdnty ? '15px' : '0')};
  width: 100%;

  @media screen and (max-width: 425px) {
    height: auto;
    margin: 10px 0px;
  }
`;

const TopItems = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const BoxTitle = styled('div')`
  color: #444444;
  font-family: 'nunito sans';
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 5px;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 425px) {
    font-size: 18px;
  }
`;

const BoxTitleSubText = styled('div')`
  color: #444444;
  font-family: 'nunito sans';
  font-size: 14px;
  font-weight: 500;

  @media screen and (max-width: 425px) {
    font-size: 13px;
  }
`;

export const SpinnerContainer = styled('div')`
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const RegistrationFormWrapper = ({
  children,
  isIdnty,
  subtitle,
  title,
}) => {
  const isComplete = useSelector((state) => state.registration.ui.isComplete);
  const isJoinComplete = useSelector((state) => state.registration.ui.isJoinComplete);
  const isSubmitting = useSelector((state) => state.registration.ui.isSubmitting);

  const completeAnimation = useSpring({ opacity: isComplete ? 1 : 0 });
  const formAnimation = useSpring({
    opacity: isSubmitting || isComplete || isJoinComplete ? 0 : 1,
    zIndex: 1,
  });
  const spinnerAnimation = useSpring({ opacity: isSubmitting ? 1 : 0, zIndex: 0 });

  return (
    <RegistrationContainer isIdnty={isIdnty}>
      <animated.div style={{ ...formAnimation, width: '100%' }}>
        <TitleBox isIdnty={isIdnty}>
          <TopItems>
            <BoxTitle>{title}</BoxTitle>
          </TopItems>
          {subtitle && <BoxTitleSubText>{subtitle}</BoxTitleSubText>}
        </TitleBox>
        {children}
      </animated.div>
      <animated.div style={spinnerAnimation}>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </animated.div>
      {!isIdnty && (
        <animated.div style={completeAnimation}>
          <SpinnerContainer>
            <Checkmark />
          </SpinnerContainer>
        </animated.div>
      )}
    </RegistrationContainer>
  );
};

RegistrationFormWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isIdnty: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired,
};

RegistrationFormWrapper.defaultProps = {
  isIdnty: false,
  subtitle: 'Enter the necessary details below to create your new account.',
};

export default RegistrationFormWrapper;
